import ForbesImage from './forbes.webp'
import FoxImage from './fox.webp'
import GolfDigestImage from './golfDigest.webp'
import GoodGolfImage from './goodGolf.webp'
import KayoImage from './kayo.webp'
import TheAustralianImage from './theAustralian.webp'
import WomensGolfImage from './womensGolf.webp'

export {
  ForbesImage,
  FoxImage,
  GolfDigestImage,
  GoodGolfImage,
  KayoImage,
  TheAustralianImage,
  WomensGolfImage,
}
